/* @flow */
import PropTypes from 'prop-types';
import * as React from 'react';

/* humanize an array:
 *
 * <HumanArray sample={['Sam', 'John', 'Smith']} total={100} />
 *    => Sam, John, Smith and 97 more
 *
 * const array = ['Sam', 'John', 'Smith', 'Doc'];
 * <HumanArray sample={array} total={array.length} />
 *    => Sam, John, Smith and 1 more
 */
class HumanArray extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    sample: PropTypes.arrayOf(PropTypes.node).isRequired,
    total: PropTypes.number.isRequired,
  };

  render() {
    const objs = this.props.sample;

    if (objs.length === 0) {
      return <span />;
    }

    if (objs.length === 1) {
      return <span>{objs[0]}</span>;
    }

    if (objs.length === 2) {
      return (
        <span>
          {objs[0]} & {objs[1]}
        </span>
      );
    }

    if (objs.length > 2) {
      return (
        <span>
          {objs[0]}, {objs[1]} & {this.props.total - 2} more
        </span>
      );
    }

    return null;
  }
}

export default HumanArray;
